<template>
  <div>
    <div
      class="q-updloader"
      style="width: 100%"
      @drop="evt => handleFileUpload(evt)"
      @dragover="evt => evt.preventDefault()"
      @dragleave="evt => evt.preventDefault()"
    >
      <div class="q-uploader__header text-center">
        <!-- Logo da empresa title -->
        <div class="text-h6 text-bold">{{ title }}</div>
      </div>

      <div style="height: 100px; border: 1px dashed #ccc; border-radius: 5px;">
        <div
          v-if="!hasImage"
          class="flex column justify-center items-center cursor-pointer"
          style="height: 100px; border: 1px dashed #ccc; border-radius: 5px;"
          @click="$refs.file.click()"
        >
          <i class="fa fa-picture-o fa-2x text-grey-5" />
          <p class="text-caption q-mt-sm text-center">
            Arraste a imagem PNG para cá ou clique para selecionar
            <br>
            Será redimensionada para 80x45px (proporção 16:9)
          </p>
        </div>
        <div v-else-if="hasImage && imageUrl !== ''" class="relative-position">
          <div>
            <q-btn
              class="absolute-top-right"
              icon="fa fa-trash"
              @click="removeImage"
              flat
            >
              <q-tooltip>Remover Logo</q-tooltip>
            </q-btn>
          </div>
          <div class="flex justify-center">
            <img :src="imageUrl"/>
          </div>
        </div>
      </div>

      <input type="file" ref="file" accept=".png" style="display: none;" @change="evt => handleFileUpload(evt)">
    </div>
  </div>
</template>

<script>
import {Loading} from "quasar";

export default {
  name: 'image-input',
  emits: ['fileUploaded', 'fileRemoved'],
  props: {
    title: {
      required: true,
      type: String
    },
    hasImage: {
      required: true,
      type: Boolean
    },
    imageUrl: {
      required: false,
      type: String
    },
    loading: {
      required: false,
      type: Boolean
    }
  },
  methods: {
    handleFileUpload(event) {
      event.preventDefault();

      const file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];

      // Validar se é PNG
      if (!file || file.type !== 'image/png') {
        this.$q.notify({
          color: 'negative',
          message: 'Apenas arquivos PNG são permitidos',
          icon: 'warning'
        });
        return;
      }

      // Redimensionar imagem se necessário
      this.resizeImage(file, 80, 45, (resizedFile) => {
        this.$emit('fileUploaded', resizedFile);
      });

      event.target.value = '';
    },

    resizeImage(file, targetWidth, targetHeight, callback) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        const { width: imgWidth, height: imgHeight } = img;

        // Calcular proporção desejada
        const targetRatio = targetWidth / targetHeight;
        const imgRatio = imgWidth / imgHeight;

        // Configurar canvas com dimensões finais
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        // Calcular dimensões de recorte para manter proporção
        let cropWidth, cropHeight, cropX, cropY;

        if (imgRatio > targetRatio) {
          // Imagem é mais larga - recortar laterais
          cropHeight = imgHeight;
          cropWidth = imgHeight * targetRatio;
          cropX = (imgWidth - cropWidth) / 2;
          cropY = 0;
        } else {
          // Imagem é mais alta - recortar topo/fundo
          cropWidth = imgWidth;
          cropHeight = imgWidth / targetRatio;
          cropX = 0;
          cropY = (imgHeight - cropHeight) / 2;
        }

        // Desenhar imagem redimensionada e recortada
        ctx.drawImage(
          img,
          cropX, cropY, cropWidth, cropHeight,  // área de origem (crop)
          0, 0, targetWidth, targetHeight       // área de destino (canvas)
        );

        // Converter para blob
        canvas.toBlob((blob) => {
          // Criar novo arquivo com nome original
          const resizedFile = new File([blob], file.name, {
            type: 'image/png',
            lastModified: Date.now()
          });

          callback(resizedFile);
        }, 'image/png', 0.9); // 0.9 = qualidade 90%
      };

      img.src = URL.createObjectURL(file);
    },
    removeImage() {
      this.$emit('fileRemoved');
    }
  },
  watch: {
    loading(value) {
      if (value) {
        Loading.show();
        return;
      }
      Loading.hide();
    }
  }
};
</script>

<style scoped>

</style>
